import { Fab } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { RadioIcon } from '@client/images/feather/RadioIcon';
import { useFormValues } from '@client/hooks/formik.hooks';
import { useCreateShowCallLink } from '@client/hooks/useCreateShowCallLink';
import { useSelector } from '@client/hooks/redux.hooks';
import { getSessionUserState } from '@client/selectors/helpers/login';
import type { FilterFormValues } from '../Main/interfaces';

const useStyles = makeStyles()((theme) => ({
  fab: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',

    [theme.breakpoints.up('md')]: {
      bottom: theme.spacing(2),
    },

    [theme.breakpoints.down('md')]: {
      position: 'fixed',
      bottom: 145,
    },
  },
  radioIcon: {
    marginRight: theme.spacing(1 / 2),
    fill: 'none',
  },
}));

export const CreateShowCallButton = () => {
  const { classes } = useStyles();

  const userState = useSelector(getSessionUserState);
  const { latLng, googlePlaceId, compiledAddress } = useFormValues<FilterFormValues>();

  const showCallLinkProps = useCreateShowCallLink({ latLng, googlePlaceId, compiledAddress });

  return (
    <Fab
      aria-label="create a show call"
      color="primary"
      id="sda-create-show-call-fab"
      className={classes.fab}
      {...showCallLinkProps}
    >
      {userState ? (
        <>
          <RadioIcon className={classes.radioIcon} />

          Create a Show Call
        </>
      ) : 'Sign Up'}
    </Fab>
  );
};
